import { createFileRoute } from '@tanstack/react-router';
import { AssessmentDefaultsEditor } from '@/components/settings/assessment-defaults-editor';

/**
 * Firm settings → Assessment defaults — `/settings/assessment-defaults`
 * (T-0219 / E20-F01). The editor owns the screen; this route only mounts it
 * under the settings shell.
 */
export const Route = createFileRoute('/settings/assessment-defaults')({
  component: AssessmentDefaultsEditor,
});
